var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"no-data__content"},[_c('i',{staticClass:"iconfont icon-wushuju",style:({ fontSize: _vm.fontSize })})])])}
var staticRenderFns = []

export { render, staticRenderFns }